var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAvatarLogo = function SvgAvatarLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9,
    fill: "#F1F1F1",
    stroke: "#858585"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#858585",
    d: "m4.758 17.48-.965-.428c.268-.643 1.125-1.018 2.036-1.447.91-.428 2.036-.91 2.036-1.5v-.803c-.322-.268-.857-.857-.964-1.714-.268-.268-.697-.75-.697-1.393 0-.375.16-.697.268-.911a9 9 0 0 1-.214-1.875c0-2.09 1.446-3.482 3.75-3.482.643 0 1.446.16 1.875.643 1.018.214 1.875 1.392 1.875 2.839 0 .91-.16 1.66-.268 2.036.107.16.214.428.214.75 0 .696-.375 1.178-.696 1.393a2.56 2.56 0 0 1-.91 1.66v.857c0 .483.963.858 1.82 1.179 1.018.375 2.09.804 2.465 1.66l-1.018.376c-.16-.429-1.018-.75-1.821-1.018-1.179-.429-2.518-.91-2.518-2.143v-1.393l.268-.16s.642-.43.642-1.286v-.375l.322-.161c.053 0 .321-.16.321-.59 0-.107-.107-.267-.16-.32l-.215-.215.107-.268s.268-.857.268-1.928c0-1.018-.589-1.768-1.071-1.768h-.322l-.16-.268c0-.215-.375-.429-1.018-.429-1.66 0-2.679.91-2.679 2.41 0 .697.268 1.876.268 1.876l.054.268-.215.268c-.053 0-.16.16-.16.375 0 .268.321.589.482.696l.214.16v.269c0 .803.697 1.232.697 1.285l.267.161v1.393c0 1.286-1.392 1.929-2.678 2.464-.59.215-1.393.59-1.5.857"
  })));
};
export default SvgAvatarLogo;